<template>
  <i
    :class="['icon', { 'icon--background': backgroundColor }]"
    :style="{ backgroundColor: backgroundColor }"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      :width="size || '40'"
      :height="size || '40'"
      viewBox="0 0 40 40"
      :fill="fill"
    >
      <path
        v-if="icon === '3-x-3'"
        d="M10 9h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1zm0 8h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1zm0 8h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1zm8-16h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1zm0 8h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1zm0 8h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1zm8-16h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1zm0 8h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1zm0 8h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1z"
      />

      <path
        v-else-if="icon === 'feedback'"
        d="M15.567 15.592h1.951a1 1 0 0 1 1 1v9.501h1.519a1 1 0 0 1 .815 1.58l-3.494 4.912a1 1 0 0 1-1.63 0l-3.494-4.912a1 1 0 0 1 .815-1.58h1.518v-9.501a1 1 0 0 1 1-1zm6.915 8.816a1 1 0 0 1-1-1v-9.501h-1.519a1 1 0 0 1-.815-1.58l3.494-4.912a1 1 0 0 1 1.63 0l3.494 4.912a1 1 0 0 1-.815 1.58h-1.518v9.501a1 1 0 0 1-1 1h-1.951z"
      />

      <path
        v-else-if="icon === 'all-boards'"
        d="M7.5 13h4.647a1.5 1.5 0 0 1 1.5 1.5v12a1.5 1.5 0 0 1-1.5 1.5H7.5A1.5 1.5 0 0 1 6 26.5v-12A1.5 1.5 0 0 1 7.5 13zm10.176 0h4.648a1.5 1.5 0 0 1 1.5 1.5v12a1.5 1.5 0 0 1-1.5 1.5h-4.648a1.5 1.5 0 0 1-1.5-1.5v-12a1.5 1.5 0 0 1 1.5-1.5zm10.177 0H32.5a1.5 1.5 0 0 1 1.5 1.5v12a1.5 1.5 0 0 1-1.5 1.5h-4.647a1.5 1.5 0 0 1-1.5-1.5v-12a1.5 1.5 0 0 1 1.5-1.5z"
      />

      <path
        v-else-if="icon === 'board'"
        d="M22.75 27.692h-6.02l-1.526 4.107c-.24.646-.968.979-1.627.744a1.237 1.237 0 0 1-.758-1.594l2.735-7.365H11a2 2 0 0 1-2-2V10.658a2 2 0 0 1 2-2h7.308a1.692 1.692 0 0 1 3.384 0H29a2 2 0 0 1 2 2v10.926a2 2 0 0 1-2 2h-5.074l2.877 7.746c.24.646-.1 1.36-.758 1.595a1.277 1.277 0 0 1-1.627-.744l-1.668-4.49zm-.732-1.971l-.793-2.137h-2.97l-.793 2.137h4.556z"
      />

      <path
        v-else-if="icon === 'check'"
        d="M10.286 22.402a1.061 1.061 0 0 1 0-1.45l1.383-1.45c.381-.4 1-.4 1.382 0l4.039 4.237L28.949 11.3c.382-.4 1-.4 1.382 0l1.383 1.45c.381.4.381 1.05 0 1.45L17.89 28.7a.947.947 0 0 1-1.383 0l-6.22-6.298z"
      />

      <path
        v-else-if="icon === 'comment-temp'"
        d="M14.595 25.097C10.281 23.833 7 21.073 7 17.428 7 12.357 12.5 8 20 8s13 4.804 13 9.428c0 4.4-5.747 8.055-12.029 8.402-2.986 3.158-6.993 5.354-8.418 5.232-1.918-.164 2.388-3.812 2.042-5.965z"
      />

      <path
        v-else-if="icon === 'cross'"
        d="M23.086 20l6.235 6.235a1 1 0 0 1 0 1.415l-1.671 1.67a1 1 0 0 1-1.415 0L20 23.086l-6.235 6.235a1 1 0 0 1-1.415 0l-1.67-1.671a1 1 0 0 1 0-1.415L16.914 20l-6.235-6.235a1 1 0 0 1 0-1.415l1.671-1.671a1 1 0 0 1 1.415 0L20 16.914l6.235-6.235a1 1 0 0 1 1.415 0l1.671 1.671a1 1 0 0 1 0 1.415L23.086 20z"
      />

      <path
        v-else-if="icon === 'designs'"
        d="M21.5 30.888C19 31.276 9 26.596 9 19.444 9 11.338 15.5 8 20.5 8S32 11.12 32 17.06s-8 5.27-11 7.654c-2.61 2.075 3 5.786.5 6.174zM15 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm5-4a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm6 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
      />

      <path
        v-else-if="icon === 'disclosure' || icon === 'next' || icon === 'back'"
        :class="[
          `${icon} === 'back' ? 'back' : ''`,
          `${icon} === 'next' ? 'next' : ''`
        ]"
        d="M20 24.355l8.153-8.068a.998.998 0 0 1 1.4 0l1.657 1.639a.973.973 0 0 1 0 1.387l-10.51 10.4a.998.998 0 0 1-1.4 0l-10.51-10.4a.973.973 0 0 1 0-1.387l1.656-1.639a.998.998 0 0 1 1.401 0L20 24.355z"
      />

      <path
        v-else-if="icon === 'download'"
        d="M18.967 8h2.066c.57 0 1.033.442 1.033.987v9.871h1.651c.57 0 1.033.442 1.033.987 0 .2-.063.395-.182.56l-3.717 5.167c-.323.45-.966.563-1.436.254a1.011 1.011 0 0 1-.266-.254l-3.717-5.167a.96.96 0 0 1 .266-1.373c.172-.113.376-.174.585-.174h1.651v-9.87c0-.546.463-.988 1.033-.988zM10 28h20a2 2 0 1 1 0 4H10a2 2 0 1 1 0-4z"
      />

      <path
        v-else-if="icon === 'information'"
        d="M20 32c-6.627 0-12-5.373-12-12S13.373 8 20 8s12 5.373 12 12-5.373 12-12 12zm-1.615-17.756c0 .432.154.812.463 1.139.31.327.695.49 1.156.49.444 0 .824-.159 1.139-.477.315-.318.472-.702.472-1.152 0-.45-.156-.834-.468-1.152a1.54 1.54 0 0 0-1.143-.477c-.443 0-.824.16-1.142.482a1.574 1.574 0 0 0-.477 1.147zm3.41 3.258l-5.026.8v1.114h.243c.591 0 .968.104 1.13.31.162.207.243.57.243 1.089v3.133c0 .512-.08.873-.238 1.083-.158.21-.537.316-1.135.316h-.243v1.115h6.462v-1.115c-.62 0-1.014-.1-1.183-.3-.169-.2-.253-.566-.253-1.099v-6.446z"
      />

      <path
        v-else-if="icon === 'library'"
        d="M25.143 11c2.379 0 4.413.523 6.104 1.57.471.29.753.776.753 1.295v12.986c0 .864-.768 1.565-1.714 1.565-.25 0-.497-.05-.723-.146-1.311-.557-2.784-.835-4.42-.835-1.082 0-2.797.522-5.143 1.565-2.34-1.043-4.055-1.565-5.143-1.565-1.636 0-3.109.278-4.42.835-.858.365-1.878.025-2.277-.759a1.452 1.452 0 0 1-.16-.66V13.865c0-.519.282-1.004.753-1.295 1.69-1.047 3.726-1.57 6.104-1.57 1.944 0 3.658.866 5.143 1.565C21.485 11.871 23.199 11 25.143 11z"
      />

      <path
        v-else-if="icon === 'oblique'"
        d="M31 18.5v3a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h20a1 1 0 0 1 1 1z"
      />

      <path
        v-else-if="icon === 'order'"
        d="M11.6 24.8h16.8a1.6 1.6 0 1 1 0 3.2H11.6a1.6 1.6 0 1 1 0-3.2zm0-6.4h16.8a1.6 1.6 0 1 1 0 3.2H11.6a1.6 1.6 0 1 1 0-3.2zm0-6.4h16.8a1.6 1.6 0 1 1 0 3.2H11.6a1.6 1.6 0 1 1 0-3.2z"
      />

      <path
        v-else-if="icon === 'play'"
        d="M28.551 21.157l-11.43 7.732A2 2 0 0 1 14 27.232V11.768a2 2 0 0 1 3.12-1.657l11.431 7.732a2 2 0 0 1 0 3.314z"
      />

      <path
        v-else-if="icon === 'plm-styles'"
        d="M14.522 30.556c-.609-.548-.913-4.952-.913-13.212-.457.944-4.109-.376-4.109-2.368 0-.858 2.283-4.256 3.652-5.19 1.37-.935 2.283-1.416 3.245-1.255.963.16 1.791 2.328 3.603 2.328 1.812 0 2.64-2.168 3.603-2.328.962-.161 1.875.32 3.245 1.254 1.37.935 3.652 4.333 3.652 5.19 0 1.993-3.652 3.313-4.109 2.37 0 8.259-.304 12.663-.913 13.211-.913.823-3.855.944-5.478.944-1.623 0-4.565-.12-5.478-.944z"
      />

      <path
        v-else-if="icon === 'plus'"
        d="M22 18h8a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-8v8a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-8h-8a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h8v-8a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v8z"
      />

      <path
        v-else-if="icon === 'renders'"
        d="M19.677 12.218c-.557-.26-.945-.85-.945-1.537 0-.929.71-1.681 1.585-1.681s1.584.752 1.584 1.68c0 .687-.388 1.278-.944 1.538 2.635.208 4.993 1.67 6.689 3.566.78-.736 1.8-1.182 2.917-1.182 2.45 0 4.437 2.145 4.437 4.79 0 2.646-1.986 4.79-4.437 4.79-.244 0-.484-.021-.718-.062-.65 1.353-1.889 2.46-3.507 3.235V28a1 1 0 0 1-1 1h-9.831a1 1 0 0 1-1-1v-.546c-2.167-.981-3.695-2.538-4.111-4.482L5 16.732l.986-2.13 5.343 3.55c1.554-2.93 4.684-5.645 8.348-5.934zm10.673 9.825c.07.007.141.01.213.01 1.362 0 2.465-1.191 2.465-2.66 0-1.47-1.103-2.662-2.465-2.662a2.36 2.36 0 0 0-1.672.706c.927 1.479 1.461 3.061 1.461 4.448 0 .053 0 .106-.002.158z"
      />

      <path
        v-else-if="icon === 'search'"
        d="M19.533 23.633a8 8 0 1 1 3 0v9.66a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-9.66zm1.5-2.823a5.037 5.037 0 1 0 0-10.074 5.037 5.037 0 0 0 0 10.074z"
      />

      <path
        v-else-if="icon === 'select-all'"
        d="M21.28 18.72a5.108 5.108 0 1 1 7.224-7.224 5.108 5.108 0 0 1-7.224 7.224zm-9.784 9.784a5.108 5.108 0 1 1 7.224-7.224 5.108 5.108 0 0 1-7.224 7.224z"
      />

      <path
        v-else-if="icon === 'send'"
        d="M13.307 22.068l10.33-2.568-10.176-2.108-2.63-7.848a1.045 1.045 0 0 1 .665-1.323 1.05 1.05 0 0 1 .854.084l18.104 10.287a1.043 1.043 0 0 1 0 1.816L12.35 30.695a1.055 1.055 0 0 1-1.435-.389 1.041 1.041 0 0 1-.085-.85l2.477-7.388z"
      />

      <path
        v-else-if="icon === 'settings'"
        d="M28.56 9.165l-.662 1.527c.397.335.77.696 1.118 1.081l1.502-.716a.518.518 0 0 1 .634.144c.201.26.393.527.576.8a.532.532 0 0 1-.062.655l-1.138 1.222c.255.453.48.924.672 1.409l1.642-.165a.51.51 0 0 1 .54.354c.1.315.187.635.263.957a.542.542 0 0 1-.28.6l-1.476.769c.082.517.13 1.04.143 1.566l1.585.408a.51.51 0 0 1 .382.52c-.015.334-.043.667-.082.998a.546.546 0 0 1-.465.473l-1.637.224c-.1.519-.234 1.032-.401 1.536l1.335.929a.519.519 0 0 1 .179.625c-.129.311-.268.617-.418.919a.54.54 0 0 1-.594.289l-1.6-.35c-.27.459-.57.9-.897 1.32l.925 1.34a.53.53 0 0 1-.047.654c-.226.251-.46.494-.702.729a.53.53 0 0 1-.652.07l-1.37-.88a12.34 12.34 0 0 1-1.286.944l.404 1.589a.541.541 0 0 1-.267.604c-.296.16-.597.31-.902.45a.518.518 0 0 1-.631-.156l-.974-1.304c-.497.184-1.004.336-1.52.454l-.165 1.646a.545.545 0 0 1-.456.482c-.33.05-.661.09-.993.117a.51.51 0 0 1-.534-.365l-.461-1.57a11.95 11.95 0 0 1-1.569-.09l-.717 1.503a.54.54 0 0 1-.588.301 13.93 13.93 0 0 1-.965-.228.511.511 0 0 1-.371-.53l.107-1.648c-.49-.176-.968-.384-1.43-.623l-1.18 1.18a.53.53 0 0 1-.65.085c-.28-.173-.554-.356-.82-.548a.52.52 0 0 1-.166-.63l.663-1.527c-.397-.335-.77-.696-1.118-1.081l-1.502.716a.518.518 0 0 1-.634-.144 13.72 13.72 0 0 1-.576-.8.532.532 0 0 1 .062-.655l1.138-1.222a11.705 11.705 0 0 1-.672-1.409l-1.642.165a.51.51 0 0 1-.54-.354 13.976 13.976 0 0 1-.263-.957.542.542 0 0 1 .28-.6l1.476-.769a11.99 11.99 0 0 1-.143-1.566l-1.585-.408a.51.51 0 0 1-.382-.52c.015-.334.043-.667.082-.998a.546.546 0 0 1 .465-.473l1.637-.224c.1-.519.234-1.032.401-1.536l-1.335-.929a.519.519 0 0 1-.179-.625c.129-.311.268-.617.418-.919a.54.54 0 0 1 .594-.289l1.6.35c.27-.459.57-.9.897-1.32l-.925-1.34a.53.53 0 0 1 .047-.654c.226-.251.46-.494.702-.729a.53.53 0 0 1 .652-.07l1.37.88a12.34 12.34 0 0 1 1.286-.944l-.404-1.589a.541.541 0 0 1 .267-.604c.296-.16.597-.31.902-.45a.518.518 0 0 1 .631.156l.974 1.304a12.27 12.27 0 0 1 1.52-.454l.165-1.646a.545.545 0 0 1 .456-.482c.33-.05.661-.09.993-.117a.51.51 0 0 1 .534.365l.461 1.57c.525-.004 1.05.026 1.569.09l.716-1.504a.54.54 0 0 1 .589-.3c.324.064.646.14.965.228a.511.511 0 0 1 .371.53l-.107 1.648c.49.176.968.384 1.43.623l1.18-1.18a.53.53 0 0 1 .65-.085c.28.173.554.356.82.548a.52.52 0 0 1 .166.63zm-13.51 4.427a1.018 1.018 0 0 0-.765-.568 1.075 1.075 0 0 0-.922.304c-.432.434-.831.914-1.188 1.438-2.44 3.586-2.183 8.177.326 11.318.206.26.525.402.86.384.335-.018.645-.195.836-.476l3.63-5.334c.214-.315.247-.717.087-1.054l-2.865-6.012zm6.102 8.177a1.083 1.083 0 0 0-.953.476l-3.629 5.334c-.191.281-.24.633-.131.948.108.314.361.555.68.647 3.878 1.129 8.267-.354 10.706-3.94a9.906 9.906 0 0 0 .9-1.632 1.052 1.052 0 0 0-.061-.961 1.02 1.02 0 0 0-.817-.49l-6.695-.382zm7.09-2.499a1.08 1.08 0 0 0 .87-.367c.22-.25.314-.585.253-.907-.45-2.369-1.793-4.547-3.935-5.979-2.141-1.432-4.681-1.851-7.063-1.373-.322.065-.6.276-.75.571-.15.295-.157.64-.018.932a2833.51 2833.51 0 0 0 2.927 6.154c.16.337.49.558.866.58 1.411.08 4.941.28 6.85.39z"
      />

      <path
        v-else-if="icon === 'transfer-list'"
        d="M15.567 15.592h1.951a1 1 0 0 1 1 1v9.501h1.519a1 1 0 0 1 .815 1.58l-3.494 4.912a1 1 0 0 1-1.63 0l-3.494-4.912a1 1 0 0 1 .815-1.58h1.518v-9.501a1 1 0 0 1 1-1zm6.915 8.816a1 1 0 0 1-1-1v-9.501h-1.519a1 1 0 0 1-.815-1.58l3.494-4.912a1 1 0 0 1 1.63 0l3.494 4.912a1 1 0 0 1-.815 1.58h-1.518v9.501a1 1 0 0 1-1 1h-1.951z"
      />

      <path
        v-else
        d="M20 31c-5.523 0-10-2.298-10-5.133S14.477 19 20 19s10 4.032 10 6.867S25.523 31 20 31zm0-13a5 5 0 1 1 0-10 5 5 0 0 1 0 10z"
      />
    </svg>
  </i>
</template>

<script>
export default {
  name: 'Icon',

  props: {
    icon: {
      type: String,
      required: true
    },
    fill: String,
    size: String,
    backgroundColor: String
  }
}
</script>

<style lang="scss" scoped>
.icon {
  display: inline-flex;
  align-items: center;
  opacity: 1;
  transition: opacity 0.3s ease-in-out;
  fill: $blue;

  &--background {
    border-radius: $border-radius-default;
  }

  .back {
    transform: rotate(90deg);
    transform-origin: center;
  }

  .next {
    transform: rotate(-90deg);
    transform-origin: center;
  }

  &:hover {
    opacity: 0.8;
  }
}
</style>
